import RailsResource from './rails-resource';

class PixService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'pix',
      ajaxLoader: false
    });
  }

  default(pixKeyId) {
    return this.post(`${this.url}/${this.resource}/${pixKeyId}/default.json`, true);
  }
}

export default new PixService();
